import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ContentProvider } from '@awp/content';
import { extractValueFromParams, trimSlash } from '@awp/core/utils';
import { AppConfig } from '@awp/core/config';

@Injectable({
  providedIn: 'root'
})
export class ThemeContextResolver implements Resolve<any> {

  constructor(private appConfig: AppConfig, private contentProvider: ContentProvider) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
    let themeId = extractValueFromParams(route, 'themeId');

    return this.contentProvider.fetchRoot().pipe(
        take(1),
        map(p => {
          return {
            ...p._embedded.properties,
            themeId,
            themeUrl: trimSlash([trimSlash(this.appConfig.BASE_HREF), themeId].join('/'))
          }
        })
      );
  }

}